import React from "react";
import { motion } from "motion/react";
import tapLogo from "@/assets/tap-logo.png";
import userTagIcon from "@/assets/user-tag.png";
import { Button } from "@/components/ui/button";
import { Pointer } from "lucide-react";
import { AirTalentLogo } from "@/components/landing/AirTalentLogo";

const Hero = ({
  setAuthModalOpen,
}: {
  setAuthModalOpen: (open: boolean) => void;
}) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-gradient-to-tr from-[#594FE0] from-[1.7%] via-[#4175E6] via-[45.57%] to-[#34C7FA] to-[96.2%]">
      <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col items-center text-center">
        <div className="text-left w-full">
          <span className="text-white uppercase text-sm md:text-lg lg:text-2xl pl-16 font-medium space-grotesk tracking-wider">
            This is
          </span>
        </div>
        <motion.div
          className="flex items-baseline justify-center flex-nowrap leading-none mb-[25px]"
          style={{
            height: "auto",
            minHeight: "clamp(60px, 12vw, 240px)", // Responsive minimum height
            width: "100%",
            overflow: "visible",
          }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="inline-flex items-baseline justify-center relative h-auto  scale-90 sm:scale-100">
            <div className="w-[320px] min-[375px]:w-[400px] min-[425px]:w-[600px] md:w-[750px] lg:w-[1100px] xl:w-[1350px] h-[60px] min-[375px]:h-[80px] min-[425px]:h-[120px] lg:h-[180px] xl:h-[220px] overflow flex items-center justify-center">
              <AirTalentLogo />
            </div>
          </div>
        </motion.div>
        
        <motion.div
          className="relative mb-7 md:mb-10 max-w-[500px] lg:max-w-full mx-auto mt-4"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
           <div id="tap-logo-floating" className="absolute top-[-10px] min-[375px]:top-[-13px] min-[425px]:top-[-17px] md:top-[-20px] lg:top-[-23px] xl:top-[-27px] left-[10px] min-[375px]:left-[-20px] min-[425px]:left-[10px] md:left-[-65px] lg:left-[-85px] xl:left-[-95px] z-10">
              <img
                src={tapLogo}
                alt="T.A.P. Logo"
                className="w-12 min-[375px]:w-14 min-[425px]:w-16 md:w-20 lg:w-24 xl:w-28 h-auto object-contain"
                style={{ transform: "rotate(-12deg)" }}
              />
          </div>
          <h2 id="hero-title" className="full-width text-white text-lg min-[375px]:text-xl min-[425px]:text-2xl lg:text-4xl xl:text-5xl font-medium space-grotesk tracking-normal mb-4 md:mb-6 uppercase leading-tight md:leading-none">
            In referrals, cash out rewards.
          </h2>
          <p className="text-white/90 text-sm min-[375px]:text-base min-[425px]:text-lg md:text-xl lg:text-2xl xl:text-3xl font-medium space-grotesk leading-relaxed px-2">
            Faster hires, Sweeter incentives
          </p>
        </motion.div>
        <motion.div
          className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 md:gap-6 px-4"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          <Button
            variant="primary"
            size="primary"
            className="w-full sm:w-auto sm:min-w-[200px] md:min-w-[225px]"
            onClick={() => setAuthModalOpen(true)}
          >
            <span>START REFERRING</span>
            <img
              src={userTagIcon}
              alt="User tag"
              className="w-5 sm:w-6 h-5 sm:h-6 brightness-0 invert"
            />
          </Button>

          <Button
            variant="secondary"
            size="primary"
            className="w-full sm:w-auto sm:min-w-[200px] md:min-w-[225px]"
            onClick={() => window.open('https://calendly.com/air-joe/talent-solutions', '_blank')}
          >
            <span>JOIN AS A CLIENT</span>
            <Pointer className="w-5 sm:w-8 h-5 sm:h-8 opacity-80" />
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
